export function getDisplayName(user) {
  if (!user) return 'User';
  const name = user.name?.trim();
  if (name) return name;
  if (user.email) return user.email.split('@')[0];
  return 'User';
}

export function getInitial(user) {
  return getDisplayName(user).charAt(0).toUpperCase();
}
